import { useEffect, useState } from 'react';
import { Link, NavLink, Route, Routes } from 'react-router-dom';
import { authApi } from './lib/api';
import { Home } from './pages/Home';
import { ShopPage } from './pages/ShopPage';
import { Checkout } from './pages/Checkout';
import { MyOrders } from './pages/MyOrders';
import { OrderTrack } from './pages/OrderTrack';
import { MagicLink } from './pages/MagicLink';
import { ReservationPage } from './pages/Reservation';
import { MyReservations, ReservationTrack } from './pages/MyReservations';
import { CartDrawer, useCartUi } from './components/CartDrawer';
import { cartCount, useCart } from './lib/cart';
import { useParams } from 'react-router-dom';

export default function App() {
  const [user, setUser] = useState<{ id: string; email: string; role: string } | null>(null);

  useEffect(() => {
    authApi.me().then((res) => {
      if (res?.ok) setUser(res.user);
    });
  }, []);

  return (
    <>
      <NavBar user={user} onLogout={() => setUser(null)} />
      <CartDrawer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/boutiques/:slug" element={<ShopPage />} />
        <Route path="/panier/:slug" element={<Checkout />} />
        <Route path="/mes-commandes" element={<MyOrders />} />
        <Route path="/mes-commandes/:id" element={<OrderTrack />} />
        <Route path="/reserver/:slug" element={<ReservationPage />} />
        <Route path="/mes-reservations" element={<MyReservations />} />
        <Route path="/mes-reservations/:id" element={<ReservationTrackRoute />} />
        <Route path="/auth/magic" element={<MagicLink onAuth={setUser} />} />
        <Route path="*" element={<div className="container"><h2>Page introuvable</h2><Link to="/">Retour à l’accueil</Link></div>} />
      </Routes>
    </>
  );
}

function NavBar({
  user,
  onLogout,
}: {
  user: { id: string; email: string; role: string } | null;
  onLogout: () => void;
}) {
  const [cart] = useCart();
  const { open } = useCartUi();
  const count = cartCount(cart);

  async function handleLogout() {
    try { await authApi.logout(); } catch { /* ignore */ }
    onLogout();
  }

  return (
    <header className="nav">
      <Link to="/" className="brand" style={{ textDecoration: 'none' }}>
        Reims Local
      </Link>
      <div className="spacer" />
      <NavLink to="/" end style={{ color: 'inherit' }}>Boutiques</NavLink>
      {user ? (
        <>
          <NavLink to="/mes-commandes" style={{ color: 'inherit' }}>Mes commandes</NavLink>
          <NavLink to="/mes-reservations" style={{ color: 'inherit' }}>Mes réservations</NavLink>
          <button className="ghost" onClick={handleLogout} title={user.email}>Déconnexion</button>
        </>
      ) : null}
      <button className="primary" onClick={open}>
        Panier{count > 0 && <span className="cart-badge">{count}</span>}
      </button>
    </header>
  );
}

function ReservationTrackRoute() {
  const params = useParams<{ id: string }>();
  if (!params.id) return null;
  return <ReservationTrack reservationId={params.id} />;
}
